<template>
    <section class="argus-glass-panel p-3 mb-3" aria-label="Правила заполнения отчётов">
        <h5>Причины просрочки и отсутствия фото</h5>
        <b-form-checkbox v-model="enabled" switch :disabled="loading || saving || !canManage">
            Включить выбор причины и проверку уточнения
        </b-form-checkbox>
        <p class="small text-muted mt-2">По умолчанию выключено: действует прежняя форма. При включении автор выбирает причину
            и пишет уточнение; оба ответа видны в отчёте и Telegram. Уже поданные отчёты не меняются.
            Проверка характеристик включается отдельно в настройках табелей.</p>
        <div v-if="error" role="alert" class="text-danger mb-2">{{ error }}</div>
        <div v-if="message" role="status" class="text-success mb-2">{{ message }}</div>
        <b-button v-if="canManage" size="sm" variant="primary" :disabled="loading || saving" @click="save">
            {{ saving ? 'Сохраняем…' : 'Сохранить правило заполнения' }}
        </b-button>
        <small v-else-if="!loading">Изменить правило может администратор.</small>
    </section>
</template>
<script>
import api from '@/utils/api';
export default {
    name: 'ReportTextQualitySettings',
    data: () => ({enabled: false, canManage: false, loading: true, saving: false, error: '', message: ''}),
    computed: {company() { return this.$store.getters.currentUser.company; }},
    watch: {company: {immediate: true, handler() { this.load(); }}},
    methods: {
        async load() {
            const company = this.company;
            this.loading = true; this.error = ''; this.message = ''; this.canManage = false; this.enabled = false;
            try {
                const {data} = await api.get('/api/shift-report/submission-settings', {ignoreModal: true});
                if (company !== this.company) return;
                this.enabled = data.text_quality_enabled === true; this.canManage = data.can_manage === true;
            } catch (_) { if (company === this.company) this.error = 'Не удалось загрузить правило. Закройте и откройте настройки повторно.'; }
            finally { if (company === this.company) this.loading = false; }
        },
        async save() {
            const company = this.company;
            this.saving = true; this.error = ''; this.message = '';
            try {
                const {data} = await api.put('/api/shift-report/submission-settings', {text_quality_enabled: this.enabled}, {ignoreModal: true});
                if (company !== this.company) return;
                this.enabled = data.text_quality_enabled === true;
                this.message = this.enabled ? 'Новая проверка отчётов включена.' : 'Сохранено: используется прежний способ заполнения.';
            } catch (error) {
                if (company === this.company) this.error = error.response && error.response.data && error.response.data.msg || 'Не удалось сохранить правило.';
            } finally { this.saving = false; }
        }
    }
};
</script>
